<div class="change-log">
  <div class="change-log__header">
    <div class="change-log__title-row">
      <div>
        <h3>Change Log</h3>
      </div>

      <div class="change-log__controls">
        <input
          type="text"
          class="change-log__search"
          placeholder="Search by path, type, value…"
          (input)="onSearch($event.target.value)"
        />

        <button class="btn btn--ghost" (click)="onClearType('formData')">
          Clear Data
        </button>
        <button class="btn btn--ghost" (click)="onClearType('variableContext')">
          Clear Variables
        </button>
        <button class="btn btn--danger" (click)="onClearAll()">
          Clear All
        </button>
      </div>
    </div>
  </div>

  <div class="change-log__body" *ngIf="filteredEntries$ | async as entries">
    <ng-container *ngIf="entries.length; else emptyState">
      <div
        class="change-log__entry"
        *ngFor="let entry of entries; trackBy: trackByTimestamp"
      >
        <div class="change-log__entry-header">
          <div class="change-log__entry-meta">
            <span class="change-log__time">
              {{ entry.timestamp | date: 'mediumTime' }}
            </span>
            <span class="change-log__date">
              {{ entry.timestamp | date: 'MMM d, y' }}
            </span>
          </div>

          <div class="change-log__entry-type">
            <span class="badge badge--type">
              {{ entry.diffType }}
            </span>
            <span class="badge badge--count">
              {{ entry.changeLog.length }} change{{ entry.changeLog.length === 1 ? '' : 's' }}
            </span>
            <button class="btn-icon" (click)="onClearEntry(entry)" title="Remove from log">
              ✕
            </button>
          </div>
        </div>

        <div class="change-log__entry-body">
          <table class="change-log__table">
            <thead>
              <tr>
                <th>Path</th>
                <th>Type</th>
                <th>Previous</th>
                <th>Current</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let diff of entry.changeLog; trackBy: trackByDiff">
                <td class="change-log__path">
                  <code>{{ diff.path }}</code>
                </td>
                <td>
                  <span [ngClass]="getBadgeClass(diff.type)">
                    {{ diff.type }}
                  </span>
                </td>
                <td class="change-log__value">
                  <pre>{{ diff.previous | json }}</pre>
                </td>
                <td class="change-log__value">
                  <pre>{{ diff.current | json }}</pre>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </ng-container>

    <ng-template #emptyState>
      <div class="change-log__empty">No changes yet…</div>
    </ng-template>
  </div>
</div>